import React from "react";
import ImgFront from '../../assets/img/avatar.jpg'

const Header = () => {
    return (
        <div className="cv__header">
            <div className="cv__header-card">
                <div className="cv__header-image">
                    <div><span>CV</span></div>
                    <img src={ImgFront} alt="avatar" />
                </div>
                <div className="cv__header-content">
                    <h4>Profil:</h4>
                    <p>Plusieurs années d'expériences dans le développement de projets web. Particulièrement la conception de site internet et d'application mobile. Autonome sur mon poste tout en appréciant le travail en équipe avec des collaborateurs sur site ou distant, je cherche à relever de nouveaux défis et à apprendre.</p>
                </div>
            </div>
        </div>
    )
}

export default Header
